"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuLink = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _theming = require("@storybook/theming");

var _styles = require("../shared/styles");

var _Link = require("../Link");

var _excluded = ["isActive"];
var MenuLink = /*#__PURE__*/(0, _theming.styled)(function (_ref) {
  var isActive = _ref.isActive,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Link.Link, (0, _extends2["default"])({}, rest, {
    tertiary: !isActive
  }));
}, process.env.NODE_ENV === "production" ? {
  target: "e14z7gyt0"
} : {
  target: "e14z7gyt0",
  label: "MenuLink"
})("outline:none;font-weight:", function (props) {
  return props.isActive ? _styles.typography.weight.bold : _styles.typography.weight.regular;
}, ";line-height:24px;text-align:left;");
exports.MenuLink = MenuLink;